export const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  WARNING: 'WARNING',
  CLEAR: 'ALERT_CLEAR',
};
